export function popupIcon(level) {
    return level == 'info' ? 'fa-solid fa-circle-info'
        : level == 'success' ? 'fa-solid fa-circle-check'
            : level == 'warning' ? 'fa-solid fa-triangle-exclamation'
                : level == 'error' ? 'fa-solid fa-hexagon-exclamation'
                    : '';
}
//# sourceMappingURL=PopupLevel.js.map